import { LucideIcon } from "lucide-react";
import * as React from "react";

import { cn } from "@/utils/core/generalUtils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: {
    icon: LucideIcon;
    position: "left" | "right";
    className?: string;
    size?: number;
    backIcon?: LucideIcon;
  };
  parentClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, min, icon, parentClassName, ...props }, ref) => {
    return (
      <div className={cn("relative w-full", parentClassName)}>
        {icon && icon.position === "left" && (
          <icon.icon
            size={icon.size || 18}
            className={cn(
              "absolute opacity-65 left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground ",
              icon.className,
            )}
          />
        )}
        <input
          type={type !== "abn" ? type : "text"}
          onChange={props.onChange}
          className={cn(
            "flex  h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background  file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground placeholder:opacity-30 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary  disabled:cursor-not-allowed disabled:opacity-50 shadow-sm",
            icon && icon.position === "left" && "pl-10",
            icon && icon.position === "right" && "pr-9",
            className,
          )}
          ref={ref}
          min={min || 0}
          {...props}
        />
        {icon && icon.position === "right" && (
          <icon.icon
            size={icon.size || 18}
            className={cn(
              "absolute opacity-65 right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground ",
              icon.className,
            )}
          />
        )}
        {icon && icon.backIcon && (
          <icon.backIcon
            size={icon.size || 18}
            className={cn(
              "absolute opacity-65 right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground ",
              icon.className,
            )}
          />
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
